// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '6a82729034c5b0ac8c3eaeb87d311199b72a7439';
export const BUILD_NUMBER = '235';
export const BUILD_TIMESTAMP = '2026-09-14T09:08:16.488Z';
